<script setup lang="ts">
import { computed } from 'vue';
import { PrimaryButton, SecondaryButton, AllowedFontSize } from '@hfc/ui-core';

const props = withDefaults(defineProps<{
  currentStep: number,
  nextHidden?: Array<number>,
  showLastStepInFlow?: boolean,
  loading?: boolean,
  continueText?: string,
  submitText?: string,
  totalSteps: number,
}>(), {
  nextHidden: () => [],
  submitText: 'Submit',
  continueText: 'Continue',
});

const offSet = props.showLastStepInFlow ? 0 : 1;
const gridColsClass = computed(() => props.currentStep === 0 ? 'grid-cols-1' : 'grid-cols-2');
</script>
<template>
  <div class="mt-4 grid" :class="gridColsClass">
    <div v-if="currentStep > 0 && currentStep <= totalSteps - offSet" class="mr-2 justify-self-start">
      <SecondaryButton label="Previous" :is-loading="loading" tabindex="-1" @click="$emit('prevSection')" outline :size="AllowedFontSize.XL" />
      <div class="flex items-center justify-center">
        <slot name="after-previous"></slot>
      </div>
    </div>
    <div v-if="currentStep < totalSteps - offSet && !(nextHidden.includes(currentStep))" class="justify-self-end">
      <div class="flex w-full justify-end">
        <PrimaryButton :is-loading="loading" @click="$emit('nextSection')" size="xl">
          {{continueText}}
        </PrimaryButton>
      </div>
      <div class="flex items-center justify-center">
        <slot name="after-continue"></slot>
      </div>
    </div>
    <div v-if="currentStep === totalSteps - offSet && !(nextHidden.includes(currentStep))" class="justify-self-end">
      <div class="flex w-full justify-end">
        <PrimaryButton :is-loading="loading" @click.prevent="$emit('submit')" size="xl">
          {{submitText}}
        </PrimaryButton>
      </div>
      <div class="flex items-center justify-center">
        <slot name="after-submit"></slot>
      </div>
    </div>
  </div>
</template>
